/**
 * Campaign Onboarding - Entry point (imports in dependency order)
 * Wiring runs when the Stimulus controller connects, not on load.
 */
import "./config";
import "./context";
import "./utils";
import "./polling";
import "./steps";
import "./run_all";
import "./fetch_operations";

console.log(
  "[campaign-onboarding] bundle loaded, globalThis.CampaignOnboarding:",
  !!globalThis.CampaignOnboarding,
);
export { runInit } from "./init";
